var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      style: _vm.modalStyle,
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        prefixNo: _vm.prefixNo,
        fullscreen: "",
        switchHelp: "",
        switchFullscreen: "",
        id: _vm.prefixNo,
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _vm.showOkFlag
            ? _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.confirmLoading },
                  on: { click: _vm.handleOk },
                },
                [_vm._v("保存（Ctrl+S）")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-tabs",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.activeKey,
                    callback: function ($$v) {
                      _vm.activeKey = $$v
                    },
                    expression: "activeKey",
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "1",
                      attrs: {
                        tab: "基本信息",
                        id: "materialHeadModal",
                        forceRender: "",
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "名称",
                                    "data-step": "1",
                                    "data-title": "名称",
                                    "data-intro": "名称必填，可以重复",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: [
                                          "name",
                                          _vm.validatorRules.name,
                                        ],
                                        expression:
                                          "[ 'name', validatorRules.name ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: { placeholder: "请输入名称" },
                                    on: { change: _vm.handleNameChange },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "规格",
                                    "data-step": "2",
                                    "data-title": "规格",
                                    "data-intro": "规格不必填，比如：10克",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: [
                                          "standard",
                                          _vm.validatorRules.standard,
                                        ],
                                        expression:
                                          "[ 'standard', validatorRules.standard ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: { placeholder: "请输入规格" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "型号",
                                    "data-step": "3",
                                    "data-title": "型号",
                                    "data-intro":
                                      "型号是比规格更小的属性，比如：RX-01",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: [
                                          "model",
                                          _vm.validatorRules.model,
                                        ],
                                        expression:
                                          "[ 'model', validatorRules.model ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: { placeholder: "请输入型号" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "单位",
                                    "data-step": "4",
                                    "data-title": "单位",
                                    "data-intro":
                                      "此处支持单个单位和多单位，勾选多单位就可以切换到多单位的下拉框，多单位需要先在【多单位】页面进行录入。\n                比如牛奶有瓶和箱两种单位，12瓶=1箱，这就构成了多单位，多单位中有个换算比例",
                                  },
                                },
                                [
                                  _c(
                                    "a-row",
                                    {
                                      staticClass: "form-row",
                                      attrs: { gutter: 24 },
                                    },
                                    [
                                      _c(
                                        "a-col",
                                        {
                                          staticStyle: {
                                            padding: "0px 0px 0px 12px",
                                          },
                                          attrs: { lg: 15, md: 15, sm: 24 },
                                        },
                                        [
                                          !_vm.unitChecked
                                            ? _c("a-input", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator.trim",
                                                    value: [
                                                      "unit",
                                                      _vm.validatorRules.unit,
                                                    ],
                                                    expression:
                                                      "[ 'unit', validatorRules.unit ]",
                                                    modifiers: { trim: true },
                                                  },
                                                ],
                                                attrs: {
                                                  placeholder: "输入单位",
                                                },
                                                on: {
                                                  change: _vm.onlyUnitOnChange,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm.unitChecked
                                            ? _c(
                                                "a-select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "decorator",
                                                      rawName: "v-decorator",
                                                      value: [
                                                        "unitId",
                                                        _vm.validatorRules
                                                          .unitId,
                                                      ],
                                                      expression:
                                                        "[ 'unitId', validatorRules.unitId ]",
                                                    },
                                                  ],
                                                  attrs: {
                                                    value: _vm.unitList,
                                                    placeholder: "选择多单位",
                                                    showSearch: "",
                                                    optionFilterProp:
                                                      "children",
                                                    dropdownMatchSelectWidth: false,
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.manyUnitOnChange,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "dropdownRender",
                                                        fn: function (menu) {
                                                          return _c(
                                                            "div",
                                                            {},
                                                            [
                                                              _c("v-nodes", {
                                                                attrs: {
                                                                  vnodes: menu,
                                                                },
                                                              }),
                                                              _c("a-divider", {
                                                                staticStyle: {
                                                                  margin:
                                                                    "4px 0",
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    padding:
                                                                      "4px 8px",
                                                                    cursor:
                                                                      "pointer",
                                                                  },
                                                                  on: {
                                                                    mousedown: (
                                                                      e
                                                                    ) =>
                                                                      e.preventDefault(),
                                                                    click:
                                                                      _vm.addUnit,
                                                                  },
                                                                },
                                                                [
                                                                  _c("a-icon", {
                                                                    attrs: {
                                                                      type: "plus",
                                                                    },
                                                                  }),
                                                                  _vm._v(
                                                                    " 新增多单位"
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2618767538
                                                  ),
                                                },
                                                _vm._l(
                                                  _vm.unitList,
                                                  function (item, index) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          value: item.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(item.name) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        {
                                          staticStyle: {
                                            padding: "0px",
                                            "text-align": "center",
                                          },
                                          attrs: { lg: 9, md: 9, sm: 24 },
                                        },
                                        [
                                          _c(
                                            "a-checkbox",
                                            {
                                              attrs: {
                                                checked: _vm.unitChecked,
                                              },
                                              on: { change: _vm.unitOnChange },
                                            },
                                            [_vm._v("多单位")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "颜色",
                                    "data-step": "5",
                                    "data-title": "颜色",
                                    "data-intro":
                                      "请填写商品的颜色，如果是多属性商品可以不填（下面有多属性开关）",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["color"],
                                        expression: "[ 'color' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: { placeholder: "请输入颜色" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "品牌",
                                    "data-step": "6",
                                    "data-title": "品牌",
                                    "data-intro":
                                      "请填写商品的品牌，方便区别不同品牌的商品",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["brand"],
                                        expression: "[ 'brand' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: { placeholder: "请输入品牌" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "助记码",
                                    "data-step": "7",
                                    "data-title": "助记码",
                                    "data-intro":
                                      "助记码自动生成，助记码是商品名称的首字母缩写",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["mnemonic"],
                                        expression: "[ 'mnemonic' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: { placeholder: "", readOnly: true },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "类别",
                                    "data-step": "8",
                                    "data-title": "类别",
                                    "data-intro":
                                      "类别需要在【商品类别】页面进行录入，录入之后在此处进行调用",
                                  },
                                },
                                [
                                  _c("a-tree-select", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["categoryId"],
                                        expression: "[ 'categoryId' ]",
                                      },
                                    ],
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      dropdownStyle: {
                                        maxHeight: "200px",
                                        overflow: "auto",
                                      },
                                      "allow-clear": "",
                                      treeData: _vm.categoryTree,
                                      placeholder: "请选择类别",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "基础重量",
                                    "data-step": "9",
                                    "data-title": "基础重量",
                                    "data-intro":
                                      "请填写基本单位对应的重量，用于计算按重量分摊费用时单据中各行商品分摊的费用成本",
                                  },
                                },
                                [
                                  _c("a-input-number", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["weight"],
                                        expression: "[ 'weight' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: "请输入基础重量(kg)",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "保质期",
                                    "data-step": "10",
                                    "data-title": "保质期",
                                    "data-intro":
                                      "保质期指的是商品的保质期(天)，主要针对带生产日期的，此类商品一般有批号",
                                  },
                                },
                                [
                                  _c("a-input-number", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["expiryNum"],
                                        expression: "[ 'expiryNum' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "请输入保质期(天)" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "仓位货架",
                                    "data-step": "11",
                                    "data-title": "仓位货架",
                                    "data-intro":
                                      "仓位货架指的是仓库中的仓位和货架号，主要适用于仓库较大的场景，方便查找商品的准确位置",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["position"],
                                        expression: "[ 'position' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "请输入仓位货架" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "制造商",
                                    "data-step": "12",
                                    "data-title": "制造商",
                                    "data-intro":
                                      "请填写商品的制造商，一般适用于制造行业",
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["mfrs"],
                                        expression: "[ 'mfrs' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: { placeholder: "请输入制造商" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { lg: 6, md: 6, sm: 6 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: _vm.mpShort.otherField1.name,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["otherField1"],
                                        expression: "[ 'otherField1' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: {
                                      placeholder:
                                        "请输入" + _vm.mpShort.otherField1.name,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { lg: 6, md: 6, sm: 6 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: _vm.mpShort.otherField2.name,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["otherField2"],
                                        expression: "[ 'otherField2' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: {
                                      placeholder:
                                        "请输入" + _vm.mpShort.otherField2.name,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { lg: 6, md: 6, sm: 6 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: _vm.mpShort.otherField3.name,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator.trim",
                                        value: ["otherField3"],
                                        expression: "[ 'otherField3' ]",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    attrs: {
                                      placeholder:
                                        "请输入" + _vm.mpShort.otherField3.name,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { lg: 6, md: 6, sm: 6 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "材料类型",
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      directives: [
                                        {
                                          name: "decorator",
                                          rawName: "v-decorator",
                                          value: ["enableAsset"],
                                          expression: "[ 'enableAsset' ]",
                                        },
                                      ],
                                      attrs: { placeholder: "请选择材料类型" },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "0" } },
                                        [_vm._v("销售商品")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "1" } },
                                        [_vm._v("固定资产物料")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "2" } },
                                        [_vm._v("原材料")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "3" } },
                                        [_vm._v("包装物")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "4" } },
                                        [_vm._v("低值易耗品")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "序列号",
                                    "data-step": "13",
                                    "data-title": "序列号",
                                    "data-intro":
                                      "此处是商品的序列号开关，如果选择了有，则在采购入库单据需要录入该商品的序列号，在销售出库单据需要选择该商品的序列号进行出库",
                                  },
                                },
                                [
                                  _c(
                                    "a-tooltip",
                                    {
                                      attrs: {
                                        title:
                                          "如果选择为有，则在采购入库单需要录入该商品的序列号",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["enableSerialNumber"],
                                              expression:
                                                "[ 'enableSerialNumber' ]",
                                            },
                                          ],
                                          attrs: { placeholder: "有无序列号" },
                                        },
                                        [
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "1" } },
                                            [_vm._v("有")]
                                          ),
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "0" } },
                                            [_vm._v("无")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "批号",
                                    "data-step": "14",
                                    "data-title": "批号",
                                    "data-intro":
                                      "此处是商品的批号开关，如果选择了有，则在采购入库单据需要录入该商品的批号和有效期，在销售出库单据需要选择该商品的批号进行出库",
                                  },
                                },
                                [
                                  _c(
                                    "a-tooltip",
                                    {
                                      attrs: {
                                        title:
                                          "如果选择为有，则在采购入库单需要录入该商品的批号和有效期",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["enableBatchNumber"],
                                              expression:
                                                "[ 'enableBatchNumber' ]",
                                            },
                                          ],
                                          attrs: { placeholder: "有无批号" },
                                        },
                                        [
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "1" } },
                                            [_vm._v("有")]
                                          ),
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "0" } },
                                            [_vm._v("无")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    label: "多属性",
                                    "data-step": "15",
                                    "data-title": "多属性",
                                    "data-intro":
                                      "多属性是针对的sku商品（比如服装、鞋帽、家纺行业），此处开关如果启用就可以在下方进行多sku的配置，配置具体的颜色、尺码之类的组合",
                                  },
                                },
                                [
                                  _c(
                                    "a-tooltip",
                                    {
                                      attrs: {
                                        title:
                                          "多属性针对服装、鞋帽、家纺等行业（注意不要勾选多单位，因为多属性商品不支持多单位，只支持单个的单位）",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["manySku"],
                                              expression: "[ 'manySku' ]",
                                            },
                                          ],
                                          attrs: {
                                            mode: "multiple",
                                            showSearch: "",
                                            optionFilterProp: "children",
                                            placeholder:
                                              "请选择多属性（可多选）",
                                            disabled: _vm.attributeStatus,
                                          },
                                          on: { change: _vm.onManySkuChange },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "dropdownRender",
                                              fn: function (menu) {
                                                return _c(
                                                  "div",
                                                  {},
                                                  [
                                                    _c("v-nodes", {
                                                      attrs: { vnodes: menu },
                                                    }),
                                                    _c("a-divider", {
                                                      staticStyle: {
                                                        margin: "4px 0",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          padding: "4px 8px",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          mousedown: (e) =>
                                                            e.preventDefault(),
                                                          click:
                                                            _vm.initMaterialAttribute,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "没找到？点此刷新列表 "
                                                        ),
                                                        _c("a-icon", {
                                                          attrs: {
                                                            type: "reload",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              },
                                            },
                                          ]),
                                        },
                                        _vm._l(
                                          _vm.materialAttributeList,
                                          function (item, index) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: index,
                                                attrs: {
                                                  value: item.value,
                                                  disabled: item.disabled,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.name) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _vm.manySkuSelected >= 1
                            ? _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: {
                                          xs: { span: 24 },
                                          sm: { span: 4 },
                                        },
                                        wrapperCol: {
                                          xs: { span: 24 },
                                          sm: { span: 20 },
                                        },
                                        label: _vm.skuOneTitle,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["skuOne"],
                                              expression: "[ 'skuOne' ]",
                                            },
                                          ],
                                          attrs: {
                                            mode: "multiple",
                                            showSearch: "",
                                            optionFilterProp: "children",
                                            placeholder: "请选择（可多选）",
                                          },
                                          on: {
                                            select: _vm.onSkuChange,
                                            deselect: _vm.onSkuOneDeSelect,
                                          },
                                        },
                                        _vm._l(
                                          _vm.skuOneList,
                                          function (item, index) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: index,
                                                attrs: { value: item.value },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.manySkuSelected >= 2
                            ? _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: {
                                          xs: { span: 24 },
                                          sm: { span: 4 },
                                        },
                                        wrapperCol: {
                                          xs: { span: 24 },
                                          sm: { span: 20 },
                                        },
                                        label: _vm.skuTwoTitle,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["skuTwo"],
                                              expression: "[ 'skuTwo' ]",
                                            },
                                          ],
                                          attrs: {
                                            mode: "multiple",
                                            showSearch: "",
                                            optionFilterProp: "children",
                                            placeholder: "请选择（可多选）",
                                          },
                                          on: {
                                            select: _vm.onSkuChange,
                                            deselect: _vm.onSkuTwoDeSelect,
                                          },
                                        },
                                        _vm._l(
                                          _vm.skuTwoList,
                                          function (item, index) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: index,
                                                attrs: { value: item.value },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.manySkuSelected >= 3
                            ? _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      attrs: {
                                        labelCol: {
                                          xs: { span: 24 },
                                          sm: { span: 4 },
                                        },
                                        wrapperCol: {
                                          xs: { span: 24 },
                                          sm: { span: 20 },
                                        },
                                        label: _vm.skuThreeTitle,
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: ["skuThree"],
                                              expression: "[ 'skuThree' ]",
                                            },
                                          ],
                                          attrs: {
                                            mode: "multiple",
                                            showSearch: "",
                                            optionFilterProp: "children",
                                            placeholder: "请选择（可多选）",
                                          },
                                          on: {
                                            select: _vm.onSkuChange,
                                            deselect: _vm.onSkuThreeDeSelect,
                                          },
                                        },
                                        _vm._l(
                                          _vm.skuThreeList,
                                          function (item, index) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: index,
                                                attrs: { value: item.value },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.name) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { id: "materialDetailModal" },
                        },
                        [
                          _c("j-editable-table", {
                            ref: "editableMeTable",
                            attrs: {
                              loading: _vm.meTable.loading,
                              columns: _vm.meTable.columns,
                              dataSource: _vm.meTable.dataSource,
                              height: 300,
                              minWidth: 1000,
                              maxHeight: 300,
                              rowNumber: true,
                              rowSelection: true,
                              actionButton: true,
                            },
                            on: {
                              valueChange: _vm.onValueChange,
                              added: _vm.onAdded,
                              deleted: _vm.onDeleted,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "buttonAfter",
                                fn: function () {
                                  return [
                                    _c(
                                      "a-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSetPrice("purchase")
                                          },
                                        },
                                      },
                                      [_vm._v("采购价-批量")]
                                    ),
                                    _c(
                                      "a-button",
                                      {
                                        staticStyle: { "margin-left": "8px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSetPrice(
                                              "commodity"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("零售价-批量")]
                                    ),
                                    _c(
                                      "a-button",
                                      {
                                        staticStyle: { "margin-left": "8px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSetPrice(
                                              "wholesale"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("销售价-批量")]
                                    ),
                                    _c(
                                      "a-button",
                                      {
                                        staticStyle: { "margin-left": "8px" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.batchSetPrice("low")
                                          },
                                        },
                                      },
                                      [_vm._v("最低售价-批量")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c("batch-set-price-modal", {
                            ref: "priceModalForm",
                            on: { ok: _vm.batchSetPriceModalFormOk },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { lg: 24, md: 24, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: _vm.labelCol,
                                    wrapperCol: {
                                      xs: { span: 24 },
                                      sm: { span: 24 },
                                    },
                                    label: "",
                                  },
                                },
                                [
                                  _c("a-textarea", {
                                    directives: [
                                      {
                                        name: "decorator",
                                        rawName: "v-decorator",
                                        value: ["remark"],
                                        expression: "[ 'remark' ]",
                                      },
                                    ],
                                    staticStyle: { "margin-top": "8px" },
                                    attrs: {
                                      rows: 1,
                                      placeholder: "请输入备注",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "2", attrs: { tab: "库存数量", forceRender: "" } },
                    [
                      _c("j-editable-table", {
                        ref: "editableDepotTable",
                        attrs: {
                          loading: _vm.depotTable.loading,
                          columns: _vm.depotTable.columns,
                          dataSource: _vm.depotTable.dataSource,
                          minWidth: 1000,
                          maxHeight: 300,
                          rowNumber: true,
                          rowSelection: false,
                          actionButton: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "buttonAfter",
                            fn: function () {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { margin: "0px 0px 8px 0px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.batchSetStock("initStock")
                                      },
                                    },
                                  },
                                  [_vm._v("期初库存-批量")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.batchSetStock("lowSafeStock")
                                      },
                                    },
                                  },
                                  [_vm._v("最低安全库存-批量")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.batchSetStock(
                                          "highSafeStock"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("最高安全库存-批量")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                      _c("batch-set-stock-modal", {
                        ref: "stockModalForm",
                        on: { ok: _vm.batchSetStockModalFormOk },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "3", attrs: { tab: "图片信息", forceRender: "" } },
                    [
                      _c(
                        "a-row",
                        {
                          staticClass: "form-row",
                          staticStyle: { "padding-top": "20px" },
                          attrs: { gutter: 24 },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { lg: 18, md: 18, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: {
                                      xs: { span: 24 },
                                      sm: { span: 3 },
                                    },
                                    wrapperCol: {
                                      xs: { span: 24 },
                                      sm: { span: 20 },
                                    },
                                    label: "图片信息",
                                  },
                                },
                                [
                                  _c("j-image-upload", {
                                    attrs: {
                                      bizPath: "material",
                                      text: "上传",
                                      isMultiple: "",
                                    },
                                    model: {
                                      value: _vm.fileList,
                                      callback: function ($$v) {
                                        _vm.fileList = $$v
                                      },
                                      expression: "fileList",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { lg: 6, md: 6, sm: 24 } }),
                        ],
                        1
                      ),
                      _c(
                        "a-row",
                        { staticClass: "form-row", attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { lg: 18, md: 18, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    labelCol: {
                                      xs: { span: 24 },
                                      sm: { span: 3 },
                                    },
                                    wrapperCol: {
                                      xs: { span: 24 },
                                      sm: { span: 20 },
                                    },
                                    label: "上传提示",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                图片最多4张，且单张大小不超过1M\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { lg: 6, md: 6, sm: 24 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("unit-modal", {
        ref: "unitModalForm",
        on: { ok: _vm.unitModalFormOk },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }